function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6060_13895)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.929 32.8966H4.35516C3.38103 32.8929 2.44803 32.5034 1.7605 31.8133C1.07296 31.1232 0.686929 30.1887 0.686935 29.2146V18.3473C0.686929 17.3732 1.07296 16.4387 1.7605 15.7486C2.44803 15.0585 3.38103 14.669 4.35516 14.6653H17.929",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6481 14.6653H42.5899C43.5664 14.6653 44.5029 15.0533 45.1934 15.7438C45.8839 16.4343 46.2718 17.3708 46.2718 18.3473V29.2146C46.2718 30.1911 45.8839 31.1276 45.1934 31.8181C44.5029 32.5086 43.5664 32.8966 42.5899 32.8966H29.6481",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.89185 14.6653V32.8966",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.87431 28.7612H6.88308",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.8082 22.8398L15.8819 25.7524",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.1856 25.7524L36.1327 21.6995L32.0935 25.7524L30.6235 24.2961",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6855 30.7808C23.1316 30.7808 22.6005 31.0008 22.2088 31.3924C21.8172 31.784 21.5972 32.3152 21.5972 32.869V32.869C21.6773 33.3578 21.9285 33.8023 22.306 34.1229C22.6835 34.4436 23.1627 34.6197 23.658 34.6197C24.1533 34.6197 24.6325 34.4436 25.01 34.1229C25.3875 33.8023 25.6387 33.3578 25.7188 32.869V32.869C25.719 32.3246 25.5065 31.8016 25.1267 31.4115C24.7469 31.0214 24.2297 30.7951 23.6855 30.7808Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.6934 14.6653V25.6563C21.6934 26.181 21.9018 26.6842 22.2728 27.0552C22.6438 27.4262 23.147 27.6346 23.6717 27.6346C24.1964 27.6346 24.6996 27.4262 25.0706 27.0552C25.4417 26.6842 25.6501 26.181 25.6501 25.6563V14.6653C25.6501 14.1406 25.4417 13.6374 25.0706 13.2664C24.6996 12.8954 24.1964 12.687 23.6717 12.687C23.147 12.687 22.6438 12.8954 22.2728 13.2664C21.9018 13.6374 21.6934 14.1406 21.6934 14.6653V14.6653Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6060_13895"
}, /*#__PURE__*/React.createElement("rect", {
  width: 47,
  height: 23.6855,
  fill: "white",
  transform: "translate(0 12)"
})));
function SvgLicensePlateMismatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensePlateMismatch);
export default __webpack_public_path__ + "static/media/license-plate-mismatch.80272f151d257f67d19d41af0299ac28.svg";
export { ForwardRef as ReactComponent };